/**
 * @generated SignedSource<<0fa3580a067304bd96cd3777ede9ae34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useSearchCorrections_itemSearch$data = {
  readonly appliedFilters: ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
      readonly urlLabel: string | null;
    } | null> | null;
  } | null> | null;
  readonly searchCorrections: {
    readonly classificationLevel: string | null;
    readonly classificationSearchTerm: string | null;
    readonly semanticSearchTerm: string | null;
  } | null;
  readonly " $fragmentType": "useSearchCorrections_itemSearch";
};
export type useSearchCorrections_itemSearch$key = {
  readonly " $data"?: useSearchCorrections_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"useSearchCorrections_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useSearchCorrections_itemSearch"
};

(node as any).hash = "756775493e381f3a421185b943c71949";

export default node;
